/** @jsx jsx */
import { Flex } from '@bottlebooks/gatsby-theme-base';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';
import FacetBox from '../DefaultFacet/FacetBox';

export default function ProductPriceFacet({ values, onChange, ...rest }) {
  const { i18n } = useLingui();
  const [min, max] = values || [];
  return (
    <FacetBox title={i18n._(t`Price range`)} {...rest}>
      <Flex gap={2}>
        <FilterField
          placeholder="min"
          value={min}
          onChange={(min) => onChange([min, max])}
          sx={{ marginBottom: 3 }}
        />
        <FilterField
          placeholder="max"
          value={max}
          onChange={(max) => onChange([min, max])}
          sx={{ marginBottom: 3 }}
        />
      </Flex>
    </FacetBox>
  );
}

function FilterField({ value = '', onChange, ...rest }) {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        flex: 1,
        paddingX: 2,
        paddingY: 1,
        border: 1,
        borderColor: 'border',
        variant: 'text.default',
        outline: 'none',
        '::placeholder': {
          color: 'lightestText',
        },
      }}
      {...rest}
    />
  );
}
